/* jshint ignore:start */
import Component from 'metal-component';
import Soy from 'metal-soy';

var templates;
goog.loadModule(function(exports) {
var soy = goog.require('soy');
var soydata = goog.require('soydata');
// This file was automatically generated from ClayTable.soy.
// Please don't edit this file by hand.

/**
 * @fileoverview Templates in namespace ClayTable.
 * @hassoydeltemplate {ClayTable.ActionsMenu.idom}
 * @hassoydeltemplate {ClayTable.Cell.idom}
 * @hassoydelcall {ClayTable.ActionsMenu.idom}
 * @hassoydelcall {ClayTable.Cell.idom}
 * @public
 */

goog.module('ClayTable.incrementaldom');

goog.require('goog.soy.data.SanitizedContent');
var incrementalDom = goog.require('incrementaldom');
goog.require('soy');
goog.require('soy.asserts');
var soyIdom = goog.require('soy.idom');

var $templateAlias4 = Soy.getTemplate('ClayActionsDropdown.incrementaldom', 'render');

var $templateAlias1 = Soy.getTemplate('ClayButton.incrementaldom', 'render');

var $templateAlias2 = Soy.getTemplate('ClayCheckbox.incrementaldom', 'render');

var $templateAlias5 = Soy.getTemplate('ClayLabel.incrementaldom', 'render');

var $templateAlias3 = Soy.getTemplate('ClayLink.incrementaldom', 'render');

var $templateAlias6 = Soy.getTemplate('ClayProgressBar.incrementaldom', 'render');


/**
 * @param {{
 *  schema: {fields: !Array<{contentRenderer: (!goog.soy.data.SanitizedContent|string), contentRendererMap: (?), fieldName: (!goog.soy.data.SanitizedContent|string), fieldsMap: (?), label: (!goog.soy.data.SanitizedContent|string), sortable: boolean, sortingOrder: (!goog.soy.data.SanitizedContent|string)}>, inputName: (!goog.soy.data.SanitizedContent|string), inputNameField: (!goog.soy.data.SanitizedContent|string), inputNamesMap: (?), inputValueField: (!goog.soy.data.SanitizedContent|string)},
 *  _handleCellContentClick: (*|null|undefined),
 *  _handleItemToggled: (*|null|undefined),
 *  _handleRowContentClick: (*|null|undefined),
 *  _handleSortingClick: (*|null|undefined),
 *  actionsMenuVariant: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  elementClasses: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  id: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  items: (!Array<?>|null|undefined),
 *  selectable: (boolean|null|undefined),
 *  showActionsMenu: (boolean|null|undefined),
 *  showCheckbox: (boolean|null|undefined),
 *  size: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  spritemap: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  tableClasses: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  useDefaultClasses: (boolean|null|undefined),
 *  wrapTable: (boolean|null|undefined)
 * }} opt_data
 * @param {Object<string, *>=} opt_ijData
 * @param {Object<string, *>=} opt_ijData_deprecated
 * @return {void}
 * @suppress {checkTypes}
 */
function $render(opt_data, opt_ijData, opt_ijData_deprecated) {
  opt_ijData = opt_ijData_deprecated || opt_ijData;
  /** @type {{fields: !Array<{contentRenderer: (!goog.soy.data.SanitizedContent|string), contentRendererMap: (?), fieldName: (!goog.soy.data.SanitizedContent|string), fieldsMap: (?), label: (!goog.soy.data.SanitizedContent|string), sortable: boolean, sortingOrder: (!goog.soy.data.SanitizedContent|string)}>, inputName: (!goog.soy.data.SanitizedContent|string), inputNameField: (!goog.soy.data.SanitizedContent|string), inputNamesMap: (?), inputValueField: (!goog.soy.data.SanitizedContent|string)}} */
  var schema = soy.asserts.assertType(goog.isObject(opt_data.schema), 'schema', opt_data.schema, '{fields: !Array<{contentRenderer: (!goog.soy.data.SanitizedContent|string), contentRendererMap: (?), fieldName: (!goog.soy.data.SanitizedContent|string), fieldsMap: (?), label: (!goog.soy.data.SanitizedContent|string), sortable: boolean, sortingOrder: (!goog.soy.data.SanitizedContent|string)}>, inputName: (!goog.soy.data.SanitizedContent|string), inputNameField: (!goog.soy.data.SanitizedContent|string), inputNamesMap: (?), inputValueField: (!goog.soy.data.SanitizedContent|string)}');
  /** @type {*|null|undefined} */
  var _handleCellContentClick = opt_data._handleCellContentClick;
  /** @type {*|null|undefined} */
  var _handleItemToggled = opt_data._handleItemToggled;
  /** @type {*|null|undefined} */
  var _handleRowContentClick = opt_data._handleRowContentClick;
  /** @type {*|null|undefined} */
  var _handleSortingClick = opt_data._handleSortingClick;
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var actionsMenuVariant = soy.asserts.assertType(opt_data.actionsMenuVariant == null || (goog.isString(opt_data.actionsMenuVariant) || opt_data.actionsMenuVariant instanceof goog.soy.data.SanitizedContent), 'actionsMenuVariant', opt_data.actionsMenuVariant, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var elementClasses = soy.asserts.assertType(opt_data.elementClasses == null || (goog.isString(opt_data.elementClasses) || opt_data.elementClasses instanceof goog.soy.data.SanitizedContent), 'elementClasses', opt_data.elementClasses, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var id = soy.asserts.assertType(opt_data.id == null || (goog.isString(opt_data.id) || opt_data.id instanceof goog.soy.data.SanitizedContent), 'id', opt_data.id, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!Array<?>|null|undefined} */
  var items = soy.asserts.assertType(opt_data.items == null || goog.isArray(opt_data.items), 'items', opt_data.items, '!Array<?>|null|undefined');
  /** @type {boolean|null|undefined} */
  var selectable = soy.asserts.assertType(opt_data.selectable == null || (goog.isBoolean(opt_data.selectable) || opt_data.selectable === 1 || opt_data.selectable === 0), 'selectable', opt_data.selectable, 'boolean|null|undefined');
  /** @type {boolean|null|undefined} */
  var showActionsMenu = soy.asserts.assertType(opt_data.showActionsMenu == null || (goog.isBoolean(opt_data.showActionsMenu) || opt_data.showActionsMenu === 1 || opt_data.showActionsMenu === 0), 'showActionsMenu', opt_data.showActionsMenu, 'boolean|null|undefined');
  /** @type {boolean|null|undefined} */
  var showCheckbox = soy.asserts.assertType(opt_data.showCheckbox == null || (goog.isBoolean(opt_data.showCheckbox) || opt_data.showCheckbox === 1 || opt_data.showCheckbox === 0), 'showCheckbox', opt_data.showCheckbox, 'boolean|null|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var size = soy.asserts.assertType(opt_data.size == null || (goog.isString(opt_data.size) || opt_data.size instanceof goog.soy.data.SanitizedContent), 'size', opt_data.size, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var spritemap = soy.asserts.assertType(opt_data.spritemap == null || (goog.isString(opt_data.spritemap) || opt_data.spritemap instanceof goog.soy.data.SanitizedContent), 'spritemap', opt_data.spritemap, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var tableClasses = soy.asserts.assertType(opt_data.tableClasses == null || (goog.isString(opt_data.tableClasses) || opt_data.tableClasses instanceof goog.soy.data.SanitizedContent), 'tableClasses', opt_data.tableClasses, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {boolean|null|undefined} */
  var useDefaultClasses = soy.asserts.assertType(opt_data.useDefaultClasses == null || (goog.isBoolean(opt_data.useDefaultClasses) || opt_data.useDefaultClasses === 1 || opt_data.useDefaultClasses === 0), 'useDefaultClasses', opt_data.useDefaultClasses, 'boolean|null|undefined');
  /** @type {boolean|null|undefined} */
  var wrapTable = soy.asserts.assertType(opt_data.wrapTable == null || (goog.isBoolean(opt_data.wrapTable) || opt_data.wrapTable === 1 || opt_data.wrapTable === 0), 'wrapTable', opt_data.wrapTable, 'boolean|null|undefined');
  var table__soy21 = function() {
    var tableAttributes__soy23 = function() {
      incrementalDom.attr('class', (useDefaultClasses != false ? 'table table-autofit table-hover table-list show-quick-actions-on-hover' : '') + (wrapTable == false && elementClasses ? ' ' + elementClasses : '') + (tableClasses ? ' ' + tableClasses : ''));
      if (id && wrapTable == false) {
        incrementalDom.attr('id', id);
      }
    };
    incrementalDom.elementOpenStart('table');
        tableAttributes__soy23();
    incrementalDom.elementOpenEnd();
      $header(opt_data, null, opt_ijData);
      $body(opt_data, null, opt_ijData);
    incrementalDom.elementClose('table');
  };
  var wrapperAttributes__soy72 = function() {
    incrementalDom.attr('class', (useDefaultClasses != false ? 'table-responsive' + (size ? '-' + size : '') : '') + (elementClasses ? ' ' + elementClasses : ''));
    if (id) {
      incrementalDom.attr('id', id);
    }
  };
  if (wrapTable != false) {
    incrementalDom.elementOpenStart('div');
        wrapperAttributes__soy72();
    incrementalDom.elementOpenEnd();
      table__soy21();
    incrementalDom.elementClose('div');
  } else {
    table__soy21();
  }
}
exports.render = $render;
/**
 * @typedef {{
 *  schema: {fields: !Array<{contentRenderer: (!goog.soy.data.SanitizedContent|string), contentRendererMap: (?), fieldName: (!goog.soy.data.SanitizedContent|string), fieldsMap: (?), label: (!goog.soy.data.SanitizedContent|string), sortable: boolean, sortingOrder: (!goog.soy.data.SanitizedContent|string)}>, inputName: (!goog.soy.data.SanitizedContent|string), inputNameField: (!goog.soy.data.SanitizedContent|string), inputNamesMap: (?), inputValueField: (!goog.soy.data.SanitizedContent|string)},
 *  _handleCellContentClick: (*|null|undefined),
 *  _handleItemToggled: (*|null|undefined),
 *  _handleRowContentClick: (*|null|undefined),
 *  _handleSortingClick: (*|null|undefined),
 *  actionsMenuVariant: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  elementClasses: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  id: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  items: (!Array<?>|null|undefined),
 *  selectable: (boolean|null|undefined),
 *  showActionsMenu: (boolean|null|undefined),
 *  showCheckbox: (boolean|null|undefined),
 *  size: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  spritemap: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  tableClasses: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  useDefaultClasses: (boolean|null|undefined),
 *  wrapTable: (boolean|null|undefined)
 * }}
 */
$render.Params;
if (goog.DEBUG) {
  $render.soyTemplateName = 'ClayTable.render';
}


/**
 * @param {{
 *  schema: {fields: !Array<{contentRenderer: (!goog.soy.data.SanitizedContent|string), contentRendererMap: (?), fieldName: (!goog.soy.data.SanitizedContent|string), fieldsMap: (?), label: (!goog.soy.data.SanitizedContent|string), sortable: boolean, sortingOrder: (!goog.soy.data.SanitizedContent|string)}>, inputName: (!goog.soy.data.SanitizedContent|string), inputNameField: (!goog.soy.data.SanitizedContent|string), inputNamesMap: (?), inputValueField: (!goog.soy.data.SanitizedContent|string)},
 *  _handleCellContentClick: (*|null|undefined),
 *  _handleItemToggled: (*|null|undefined),
 *  _handleRowContentClick: (*|null|undefined),
 *  actionsMenuVariant: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  id: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  items: (!Array<?>|null|undefined),
 *  selectable: (boolean|null|undefined),
 *  showActionsMenu: (boolean|null|undefined),
 *  showCheckbox: (boolean|null|undefined),
 *  spritemap: (!goog.soy.data.SanitizedContent|null|string|undefined)
 * }} opt_data
 * @param {Object<string, *>=} opt_ijData
 * @param {Object<string, *>=} opt_ijData_deprecated
 * @return {void}
 * @suppress {checkTypes}
 */
function $body(opt_data, opt_ijData, opt_ijData_deprecated) {
  opt_ijData = opt_ijData_deprecated || opt_ijData;
  /** @type {{fields: !Array<{contentRenderer: (!goog.soy.data.SanitizedContent|string), contentRendererMap: (?), fieldName: (!goog.soy.data.SanitizedContent|string), fieldsMap: (?), label: (!goog.soy.data.SanitizedContent|string), sortable: boolean, sortingOrder: (!goog.soy.data.SanitizedContent|string)}>, inputName: (!goog.soy.data.SanitizedContent|string), inputNameField: (!goog.soy.data.SanitizedContent|string), inputNamesMap: (?), inputValueField: (!goog.soy.data.SanitizedContent|string)}} */
  var schema = soy.asserts.assertType(goog.isObject(opt_data.schema), 'schema', opt_data.schema, '{fields: !Array<{contentRenderer: (!goog.soy.data.SanitizedContent|string), contentRendererMap: (?), fieldName: (!goog.soy.data.SanitizedContent|string), fieldsMap: (?), label: (!goog.soy.data.SanitizedContent|string), sortable: boolean, sortingOrder: (!goog.soy.data.SanitizedContent|string)}>, inputName: (!goog.soy.data.SanitizedContent|string), inputNameField: (!goog.soy.data.SanitizedContent|string), inputNamesMap: (?), inputValueField: (!goog.soy.data.SanitizedContent|string)}');
  /** @type {*|null|undefined} */
  var _handleCellContentClick = opt_data._handleCellContentClick;
  /** @type {*|null|undefined} */
  var _handleItemToggled = opt_data._handleItemToggled;
  /** @type {*|null|undefined} */
  var _handleRowContentClick = opt_data._handleRowContentClick;
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var actionsMenuVariant = soy.asserts.assertType(opt_data.actionsMenuVariant == null || (goog.isString(opt_data.actionsMenuVariant) || opt_data.actionsMenuVariant instanceof goog.soy.data.SanitizedContent), 'actionsMenuVariant', opt_data.actionsMenuVariant, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var id = soy.asserts.assertType(opt_data.id == null || (goog.isString(opt_data.id) || opt_data.id instanceof goog.soy.data.SanitizedContent), 'id', opt_data.id, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!Array<?>|null|undefined} */
  var items = soy.asserts.assertType(opt_data.items == null || goog.isArray(opt_data.items), 'items', opt_data.items, '!Array<?>|null|undefined');
  /** @type {boolean|null|undefined} */
  var selectable = soy.asserts.assertType(opt_data.selectable == null || (goog.isBoolean(opt_data.selectable) || opt_data.selectable === 1 || opt_data.selectable === 0), 'selectable', opt_data.selectable, 'boolean|null|undefined');
  /** @type {boolean|null|undefined} */
  var showActionsMenu = soy.asserts.assertType(opt_data.showActionsMenu == null || (goog.isBoolean(opt_data.showActionsMenu) || opt_data.showActionsMenu === 1 || opt_data.showActionsMenu === 0), 'showActionsMenu', opt_data.showActionsMenu, 'boolean|null|undefined');
  /** @type {boolean|null|undefined} */
  var showCheckbox = soy.asserts.assertType(opt_data.showCheckbox == null || (goog.isBoolean(opt_data.showCheckbox) || opt_data.showCheckbox === 1 || opt_data.showCheckbox === 0), 'showCheckbox', opt_data.showCheckbox, 'boolean|null|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var spritemap = soy.asserts.assertType(opt_data.spritemap == null || (goog.isString(opt_data.spritemap) || opt_data.spritemap instanceof goog.soy.data.SanitizedContent), 'spritemap', opt_data.spritemap, '!goog.soy.data.SanitizedContent|null|string|undefined');
  incrementalDom.elementOpen('tbody');
    if (items) {
      $rows({_handleCellContentClick: _handleCellContentClick, _handleItemToggled: _handleItemToggled, _handleRowContentClick: _handleRowContentClick, actionsMenuVariant: actionsMenuVariant, groupName: id, items: items, schema: schema, selectable: selectable, showActionsMenu: showActionsMenu, showCheckbox: showCheckbox, spritemap: spritemap}, null, opt_ijData);
    }
  incrementalDom.elementClose('tbody');
}
exports.body = $body;
/**
 * @typedef {{
 *  schema: {fields: !Array<{contentRenderer: (!goog.soy.data.SanitizedContent|string), contentRendererMap: (?), fieldName: (!goog.soy.data.SanitizedContent|string), fieldsMap: (?), label: (!goog.soy.data.SanitizedContent|string), sortable: boolean, sortingOrder: (!goog.soy.data.SanitizedContent|string)}>, inputName: (!goog.soy.data.SanitizedContent|string), inputNameField: (!goog.soy.data.SanitizedContent|string), inputNamesMap: (?), inputValueField: (!goog.soy.data.SanitizedContent|string)},
 *  _handleCellContentClick: (*|null|undefined),
 *  _handleItemToggled: (*|null|undefined),
 *  _handleRowContentClick: (*|null|undefined),
 *  actionsMenuVariant: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  id: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  items: (!Array<?>|null|undefined),
 *  selectable: (boolean|null|undefined),
 *  showActionsMenu: (boolean|null|undefined),
 *  showCheckbox: (boolean|null|undefined),
 *  spritemap: (!goog.soy.data.SanitizedContent|null|string|undefined)
 * }}
 */
$body.Params;
if (goog.DEBUG) {
  $body.soyTemplateName = 'ClayTable.body';
}


/**
 * @param {{
 *  schema: {fields: !Array<{contentRenderer: (!goog.soy.data.SanitizedContent|string), contentRendererMap: (?), fieldName: (!goog.soy.data.SanitizedContent|string), fieldsMap: (?), label: (!goog.soy.data.SanitizedContent|string), sortable: boolean, sortingOrder: (!goog.soy.data.SanitizedContent|string)}>, inputName: (!goog.soy.data.SanitizedContent|string), inputNameField: (!goog.soy.data.SanitizedContent|string), inputNamesMap: (?), inputValueField: (!goog.soy.data.SanitizedContent|string)},
 *  _handleSortingClick: (*|null|undefined),
 *  selectable: (boolean|null|undefined),
 *  showActionsMenu: (boolean|null|undefined),
 *  showCheckbox: (boolean|null|undefined),
 *  spritemap: (!goog.soy.data.SanitizedContent|null|string|undefined)
 * }} opt_data
 * @param {Object<string, *>=} opt_ijData
 * @param {Object<string, *>=} opt_ijData_deprecated
 * @return {void}
 * @suppress {checkTypes}
 */
function $header(opt_data, opt_ijData, opt_ijData_deprecated) {
  opt_ijData = opt_ijData_deprecated || opt_ijData;
  var $$temp;
  /** @type {{fields: !Array<{contentRenderer: (!goog.soy.data.SanitizedContent|string), contentRendererMap: (?), fieldName: (!goog.soy.data.SanitizedContent|string), fieldsMap: (?), label: (!goog.soy.data.SanitizedContent|string), sortable: boolean, sortingOrder: (!goog.soy.data.SanitizedContent|string)}>, inputName: (!goog.soy.data.SanitizedContent|string), inputNameField: (!goog.soy.data.SanitizedContent|string), inputNamesMap: (?), inputValueField: (!goog.soy.data.SanitizedContent|string)}} */
  var schema = soy.asserts.assertType(goog.isObject(opt_data.schema), 'schema', opt_data.schema, '{fields: !Array<{contentRenderer: (!goog.soy.data.SanitizedContent|string), contentRendererMap: (?), fieldName: (!goog.soy.data.SanitizedContent|string), fieldsMap: (?), label: (!goog.soy.data.SanitizedContent|string), sortable: boolean, sortingOrder: (!goog.soy.data.SanitizedContent|string)}>, inputName: (!goog.soy.data.SanitizedContent|string), inputNameField: (!goog.soy.data.SanitizedContent|string), inputNamesMap: (?), inputValueField: (!goog.soy.data.SanitizedContent|string)}');
  /** @type {*|null|undefined} */
  var _handleSortingClick = opt_data._handleSortingClick;
  /** @type {boolean|null|undefined} */
  var selectable = soy.asserts.assertType(opt_data.selectable == null || (goog.isBoolean(opt_data.selectable) || opt_data.selectable === 1 || opt_data.selectable === 0), 'selectable', opt_data.selectable, 'boolean|null|undefined');
  /** @type {boolean|null|undefined} */
  var showActionsMenu = soy.asserts.assertType(opt_data.showActionsMenu == null || (goog.isBoolean(opt_data.showActionsMenu) || opt_data.showActionsMenu === 1 || opt_data.showActionsMenu === 0), 'showActionsMenu', opt_data.showActionsMenu, 'boolean|null|undefined');
  /** @type {boolean|null|undefined} */
  var showCheckbox = soy.asserts.assertType(opt_data.showCheckbox == null || (goog.isBoolean(opt_data.showCheckbox) || opt_data.showCheckbox === 1 || opt_data.showCheckbox === 0), 'showCheckbox', opt_data.showCheckbox, 'boolean|null|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var spritemap = soy.asserts.assertType(opt_data.spritemap == null || (goog.isString(opt_data.spritemap) || opt_data.spritemap instanceof goog.soy.data.SanitizedContent), 'spritemap', opt_data.spritemap, '!goog.soy.data.SanitizedContent|null|string|undefined');
  incrementalDom.elementOpen('thead');
    incrementalDom.elementOpen('tr');
      if (selectable && showCheckbox) {
        incrementalDom.elementOpen('th');
        incrementalDom.elementClose('th');
      }
      if (schema.fields) {
        var fieldSchema182List = schema.fields;
        var fieldSchema182ListLen = fieldSchema182List.length;
        for (var fieldSchema182Index = 0; fieldSchema182Index < fieldSchema182ListLen; fieldSchema182Index++) {
            var fieldSchema182Data = fieldSchema182List[fieldSchema182Index];
            var tableHeaderAttributes__soy157 = function() {
              if (fieldSchema182Index == 0) {
                incrementalDom.attr('class', 'table-cell-expand');
              }
            };
            incrementalDom.elementOpenStart('th');
                tableHeaderAttributes__soy157();
            incrementalDom.elementOpenEnd();
              if (!fieldSchema182Data.sortable) {
                soyIdom.print(fieldSchema182Data.label);
              } else {
                $templateAlias1({events: {click: _handleSortingClick}, icon: fieldSchema182Data.sortingOrder ? 'order-arrow-' + (fieldSchema182Data.sortingOrder == 'asc' ? 'up' : 'down') : null, iconAlignment: 'right', label: ($$temp = fieldSchema182Data.label) == null ? fieldSchema182Data.fieldName : $$temp, spritemap: spritemap, style: 'unstyled'}, null, opt_ijData);
              }
            incrementalDom.elementClose('th');
          }
      }
      if (showActionsMenu) {
        incrementalDom.elementOpen('th');
        incrementalDom.elementClose('th');
      }
    incrementalDom.elementClose('tr');
  incrementalDom.elementClose('thead');
}
exports.header = $header;
/**
 * @typedef {{
 *  schema: {fields: !Array<{contentRenderer: (!goog.soy.data.SanitizedContent|string), contentRendererMap: (?), fieldName: (!goog.soy.data.SanitizedContent|string), fieldsMap: (?), label: (!goog.soy.data.SanitizedContent|string), sortable: boolean, sortingOrder: (!goog.soy.data.SanitizedContent|string)}>, inputName: (!goog.soy.data.SanitizedContent|string), inputNameField: (!goog.soy.data.SanitizedContent|string), inputNamesMap: (?), inputValueField: (!goog.soy.data.SanitizedContent|string)},
 *  _handleSortingClick: (*|null|undefined),
 *  selectable: (boolean|null|undefined),
 *  showActionsMenu: (boolean|null|undefined),
 *  showCheckbox: (boolean|null|undefined),
 *  spritemap: (!goog.soy.data.SanitizedContent|null|string|undefined)
 * }}
 */
$header.Params;
if (goog.DEBUG) {
  $header.soyTemplateName = 'ClayTable.header';
}


/**
 * @param {{
 *  item: (?),
 *  schema: {fields: !Array<{contentRenderer: (!goog.soy.data.SanitizedContent|string), contentRendererMap: (?), fieldName: (!goog.soy.data.SanitizedContent|string), fieldsMap: (?), label: (!goog.soy.data.SanitizedContent|string), sortable: boolean, sortingOrder: (!goog.soy.data.SanitizedContent|string)}>, inputName: (!goog.soy.data.SanitizedContent|string), inputNameField: (!goog.soy.data.SanitizedContent|string), inputNamesMap: (?), inputValueField: (!goog.soy.data.SanitizedContent|string)},
 *  _handleCellContentClick: (*|null|undefined),
 *  _handleItemToggled: (*|null|undefined),
 *  _handleRowContentClick: (*|null|undefined),
 *  actionsMenuVariant: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  groupName: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  selectable: (boolean|null|undefined),
 *  showActionsMenu: (boolean|null|undefined),
 *  showCheckbox: (boolean|null|undefined),
 *  spritemap: (!goog.soy.data.SanitizedContent|null|string|undefined)
 * }} opt_data
 * @param {Object<string, *>=} opt_ijData
 * @param {Object<string, *>=} opt_ijData_deprecated
 * @return {void}
 * @suppress {checkTypes}
 */
function $row(opt_data, opt_ijData, opt_ijData_deprecated) {
  opt_ijData = opt_ijData_deprecated || opt_ijData;
  var $$temp;
  /** @type {?} */
  var item = opt_data.item;
  /** @type {{fields: !Array<{contentRenderer: (!goog.soy.data.SanitizedContent|string), contentRendererMap: (?), fieldName: (!goog.soy.data.SanitizedContent|string), fieldsMap: (?), label: (!goog.soy.data.SanitizedContent|string), sortable: boolean, sortingOrder: (!goog.soy.data.SanitizedContent|string)}>, inputName: (!goog.soy.data.SanitizedContent|string), inputNameField: (!goog.soy.data.SanitizedContent|string), inputNamesMap: (?), inputValueField: (!goog.soy.data.SanitizedContent|string)}} */
  var schema = soy.asserts.assertType(goog.isObject(opt_data.schema), 'schema', opt_data.schema, '{fields: !Array<{contentRenderer: (!goog.soy.data.SanitizedContent|string), contentRendererMap: (?), fieldName: (!goog.soy.data.SanitizedContent|string), fieldsMap: (?), label: (!goog.soy.data.SanitizedContent|string), sortable: boolean, sortingOrder: (!goog.soy.data.SanitizedContent|string)}>, inputName: (!goog.soy.data.SanitizedContent|string), inputNameField: (!goog.soy.data.SanitizedContent|string), inputNamesMap: (?), inputValueField: (!goog.soy.data.SanitizedContent|string)}');
  /** @type {*|null|undefined} */
  var _handleCellContentClick = opt_data._handleCellContentClick;
  /** @type {*|null|undefined} */
  var _handleItemToggled = opt_data._handleItemToggled;
  /** @type {*|null|undefined} */
  var _handleRowContentClick = opt_data._handleRowContentClick;
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var actionsMenuVariant = soy.asserts.assertType(opt_data.actionsMenuVariant == null || (goog.isString(opt_data.actionsMenuVariant) || opt_data.actionsMenuVariant instanceof goog.soy.data.SanitizedContent), 'actionsMenuVariant', opt_data.actionsMenuVariant, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var groupName = soy.asserts.assertType(opt_data.groupName == null || (goog.isString(opt_data.groupName) || opt_data.groupName instanceof goog.soy.data.SanitizedContent), 'groupName', opt_data.groupName, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {boolean|null|undefined} */
  var selectable = soy.asserts.assertType(opt_data.selectable == null || (goog.isBoolean(opt_data.selectable) || opt_data.selectable === 1 || opt_data.selectable === 0), 'selectable', opt_data.selectable, 'boolean|null|undefined');
  /** @type {boolean|null|undefined} */
  var showActionsMenu = soy.asserts.assertType(opt_data.showActionsMenu == null || (goog.isBoolean(opt_data.showActionsMenu) || opt_data.showActionsMenu === 1 || opt_data.showActionsMenu === 0), 'showActionsMenu', opt_data.showActionsMenu, 'boolean|null|undefined');
  /** @type {boolean|null|undefined} */
  var showCheckbox = soy.asserts.assertType(opt_data.showCheckbox == null || (goog.isBoolean(opt_data.showCheckbox) || opt_data.showCheckbox === 1 || opt_data.showCheckbox === 0), 'showCheckbox', opt_data.showCheckbox, 'boolean|null|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var spritemap = soy.asserts.assertType(opt_data.spritemap == null || (goog.isString(opt_data.spritemap) || opt_data.spritemap instanceof goog.soy.data.SanitizedContent), 'spritemap', opt_data.spritemap, '!goog.soy.data.SanitizedContent|null|string|undefined');
  var attributes__soy203 = function() {
    incrementalDom.attr('class', (selectable && item.selected ? 'table-active' : '') + (item.rowClasses ? ' ' + item.rowClasses : ''));
    incrementalDom.attr('data-onclick', _handleRowContentClick);
  };
  incrementalDom.elementOpenStart('tr');
      attributes__soy203();
  incrementalDom.elementOpenEnd();
    if (selectable && showCheckbox) {
      incrementalDom.elementOpen('td');
        var param228 = '';
        if (item.selected) {
          var msg_3728__soy3729 = '';
          /** @desc The word 'select' used as a verb */
          var MSG_EXTERNAL_7982607155521959690 = goog.getMsg('select');
          msg_3728__soy3729 += MSG_EXTERNAL_7982607155521959690;
          param228 += msg_3728__soy3729;
        } else {
          var msg_3731__soy3732 = '';
          /** @desc The word 'deselect' used as a verb */
          var MSG_EXTERNAL_8588064239486461354 = goog.getMsg('deselect');
          msg_3731__soy3732 += MSG_EXTERNAL_8588064239486461354;
          param228 += msg_3731__soy3732;
        }
        var $tmp$$1 = null;
        if (schema.inputName) {
          $tmp$$1 = schema.inputName;
        } else if (schema.inputNameField && schema.inputNamesMap) {
          var $tmp = null;
          if (schema.inputNamesMap[item[schema.inputNameField]]) {
            $tmp = schema.inputNamesMap[item[schema.inputNameField]];
          } else if (schema.inputNamesMap['*']) {
            $tmp = schema.inputNamesMap['*'];
          } else {
            $tmp = '';
          }
          $tmp$$1 = $tmp;
        } else {
          $tmp$$1 = '';
        }
        $templateAlias2({ariaLabelledBy: groupName ? 'group-' + groupName : null, checked: item.selected, disabled: item.disabled, events: {change: _handleItemToggled}, label: param228, name: '' + $tmp$$1, showLabel: false, value: item[schema.inputValueField]}, null, opt_ijData);
      incrementalDom.elementClose('td');
    }
    if (schema.fields) {
      var fieldSchema306List = schema.fields;
      var fieldSchema306ListLen = fieldSchema306List.length;
      for (var fieldSchema306Index = 0; fieldSchema306Index < fieldSchema306ListLen; fieldSchema306Index++) {
          var fieldSchema306Data = fieldSchema306List[fieldSchema306Index];
          var variant__soy274 = '';
          var $tmp$$3 = null;
if (fieldSchema306Data.contentRenderer) {
  $tmp$$3 = fieldSchema306Data.contentRenderer;
} else if (fieldSchema306Data.fieldsMap && fieldSchema306Data.fieldsMap.contentRenderer) {
  var $tmp$$2 = null;
  if (fieldSchema306Data.contentRendererMap && fieldSchema306Data.contentRendererMap[item[fieldSchema306Data.fieldsMap.contentRenderer]]) {
    $tmp$$2 = fieldSchema306Data.contentRendererMap[item[fieldSchema306Data.fieldsMap.contentRenderer]];
  } else if (fieldSchema306Data.contentRendererMap['*']) {
    $tmp$$2 = fieldSchema306Data.contentRendererMap['*'];
  } else if (fieldSchema306Index == 0) {
    $tmp$$2 = 'main';
  } else {
    $tmp$$2 = '';
  }
  $tmp$$3 = $tmp$$2;
} else if (fieldSchema306Index == 0) {
  $tmp$$3 = 'main';
} else {
  $tmp$$3 = '';
}
variant__soy274 += $tmp$$3;
          soy.$$getDelegateFn(soy.$$getDelTemplateId('ClayTable.Cell.idom'), variant__soy274, false)({_handleCellContentClick: _handleCellContentClick, fieldSchema: fieldSchema306Data, item: item, spritemap: spritemap, value: ($$temp = item[fieldSchema306Data.fieldName]) == null ? null : $$temp}, null, opt_ijData);
        }
    }
    if (showActionsMenu && item.actionItems && spritemap) {
      soy.$$getDelegateFn(soy.$$getDelTemplateId('ClayTable.ActionsMenu.idom'), actionsMenuVariant, false)({actionItems: item.actionItems, spritemap: spritemap}, null, opt_ijData);
    }
  incrementalDom.elementClose('tr');
}
exports.row = $row;
/**
 * @typedef {{
 *  item: (?),
 *  schema: {fields: !Array<{contentRenderer: (!goog.soy.data.SanitizedContent|string), contentRendererMap: (?), fieldName: (!goog.soy.data.SanitizedContent|string), fieldsMap: (?), label: (!goog.soy.data.SanitizedContent|string), sortable: boolean, sortingOrder: (!goog.soy.data.SanitizedContent|string)}>, inputName: (!goog.soy.data.SanitizedContent|string), inputNameField: (!goog.soy.data.SanitizedContent|string), inputNamesMap: (?), inputValueField: (!goog.soy.data.SanitizedContent|string)},
 *  _handleCellContentClick: (*|null|undefined),
 *  _handleItemToggled: (*|null|undefined),
 *  _handleRowContentClick: (*|null|undefined),
 *  actionsMenuVariant: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  groupName: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  selectable: (boolean|null|undefined),
 *  showActionsMenu: (boolean|null|undefined),
 *  showCheckbox: (boolean|null|undefined),
 *  spritemap: (!goog.soy.data.SanitizedContent|null|string|undefined)
 * }}
 */
$row.Params;
if (goog.DEBUG) {
  $row.soyTemplateName = 'ClayTable.row';
}


/**
 * @param {{
 *  items: !Array<?>,
 *  schema: {fields: !Array<{contentRenderer: (!goog.soy.data.SanitizedContent|string), contentRendererMap: (?), fieldName: (!goog.soy.data.SanitizedContent|string), fieldsMap: (?), label: (!goog.soy.data.SanitizedContent|string), sortable: boolean, sortingOrder: (!goog.soy.data.SanitizedContent|string)}>, inputName: (!goog.soy.data.SanitizedContent|string), inputNameField: (!goog.soy.data.SanitizedContent|string), inputNamesMap: (?), inputValueField: (!goog.soy.data.SanitizedContent|string)},
 *  _handleCellContentClick: (*|null|undefined),
 *  _handleItemToggled: (*|null|undefined),
 *  _handleRowContentClick: (*|null|undefined),
 *  actionsMenuVariant: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  groupName: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  selectable: (boolean|null|undefined),
 *  showActionsMenu: (boolean|null|undefined),
 *  showCheckbox: (boolean|null|undefined),
 *  spritemap: (!goog.soy.data.SanitizedContent|null|string|undefined)
 * }} opt_data
 * @param {Object<string, *>=} opt_ijData
 * @param {Object<string, *>=} opt_ijData_deprecated
 * @return {void}
 * @suppress {checkTypes}
 */
function $rows(opt_data, opt_ijData, opt_ijData_deprecated) {
  opt_ijData = opt_ijData_deprecated || opt_ijData;
  /** @type {!Array<?>} */
  var items = soy.asserts.assertType(goog.isArray(opt_data.items), 'items', opt_data.items, '!Array<?>');
  /** @type {{fields: !Array<{contentRenderer: (!goog.soy.data.SanitizedContent|string), contentRendererMap: (?), fieldName: (!goog.soy.data.SanitizedContent|string), fieldsMap: (?), label: (!goog.soy.data.SanitizedContent|string), sortable: boolean, sortingOrder: (!goog.soy.data.SanitizedContent|string)}>, inputName: (!goog.soy.data.SanitizedContent|string), inputNameField: (!goog.soy.data.SanitizedContent|string), inputNamesMap: (?), inputValueField: (!goog.soy.data.SanitizedContent|string)}} */
  var schema = soy.asserts.assertType(goog.isObject(opt_data.schema), 'schema', opt_data.schema, '{fields: !Array<{contentRenderer: (!goog.soy.data.SanitizedContent|string), contentRendererMap: (?), fieldName: (!goog.soy.data.SanitizedContent|string), fieldsMap: (?), label: (!goog.soy.data.SanitizedContent|string), sortable: boolean, sortingOrder: (!goog.soy.data.SanitizedContent|string)}>, inputName: (!goog.soy.data.SanitizedContent|string), inputNameField: (!goog.soy.data.SanitizedContent|string), inputNamesMap: (?), inputValueField: (!goog.soy.data.SanitizedContent|string)}');
  /** @type {*|null|undefined} */
  var _handleCellContentClick = opt_data._handleCellContentClick;
  /** @type {*|null|undefined} */
  var _handleItemToggled = opt_data._handleItemToggled;
  /** @type {*|null|undefined} */
  var _handleRowContentClick = opt_data._handleRowContentClick;
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var actionsMenuVariant = soy.asserts.assertType(opt_data.actionsMenuVariant == null || (goog.isString(opt_data.actionsMenuVariant) || opt_data.actionsMenuVariant instanceof goog.soy.data.SanitizedContent), 'actionsMenuVariant', opt_data.actionsMenuVariant, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var groupName = soy.asserts.assertType(opt_data.groupName == null || (goog.isString(opt_data.groupName) || opt_data.groupName instanceof goog.soy.data.SanitizedContent), 'groupName', opt_data.groupName, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {boolean|null|undefined} */
  var selectable = soy.asserts.assertType(opt_data.selectable == null || (goog.isBoolean(opt_data.selectable) || opt_data.selectable === 1 || opt_data.selectable === 0), 'selectable', opt_data.selectable, 'boolean|null|undefined');
  /** @type {boolean|null|undefined} */
  var showActionsMenu = soy.asserts.assertType(opt_data.showActionsMenu == null || (goog.isBoolean(opt_data.showActionsMenu) || opt_data.showActionsMenu === 1 || opt_data.showActionsMenu === 0), 'showActionsMenu', opt_data.showActionsMenu, 'boolean|null|undefined');
  /** @type {boolean|null|undefined} */
  var showCheckbox = soy.asserts.assertType(opt_data.showCheckbox == null || (goog.isBoolean(opt_data.showCheckbox) || opt_data.showCheckbox === 1 || opt_data.showCheckbox === 0), 'showCheckbox', opt_data.showCheckbox, 'boolean|null|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var spritemap = soy.asserts.assertType(opt_data.spritemap == null || (goog.isString(opt_data.spritemap) || opt_data.spritemap instanceof goog.soy.data.SanitizedContent), 'spritemap', opt_data.spritemap, '!goog.soy.data.SanitizedContent|null|string|undefined');
  var item391List = items;
  var item391ListLen = item391List.length;
  for (var item391Index = 0; item391Index < item391ListLen; item391Index++) {
      var item391Data = item391List[item391Index];
      if (item391Data.items) {
        var currentgroupName__soy335 = '';
        currentgroupName__soy335 += groupName ? groupName + '-' : '';
        currentgroupName__soy335 += item391Index;
        var dividerAttributes__soy346 = function() {
          incrementalDom.attr('class', 'table-divider');
          incrementalDom.attr('id', 'group-' + currentgroupName__soy335);
        };
        incrementalDom.elementOpenStart('tr');
            dividerAttributes__soy346();
        incrementalDom.elementOpenEnd();
          var cellAttributes__soy353 = function() {
            incrementalDom.attr('colspan', (schema.fields.length) + (showCheckbox && selectable ? 1 : 0) + (showActionsMenu ? 1 : 0));
          };
          incrementalDom.elementOpenStart('td');
              cellAttributes__soy353();
          incrementalDom.elementOpenEnd();
            soyIdom.print(item391Data.label);
          incrementalDom.elementClose('td');
        incrementalDom.elementClose('tr');
        $rows({_handleCellContentClick: _handleCellContentClick, _handleItemToggled: _handleItemToggled, _handleRowContentClick: _handleRowContentClick, actionsMenuVariant: actionsMenuVariant, groupName: currentgroupName__soy335, items: item391Data.items, schema: schema, selectable: selectable, showActionsMenu: showActionsMenu, showCheckbox: showCheckbox, spritemap: spritemap}, null, opt_ijData);
      } else {
        $row({_handleCellContentClick: _handleCellContentClick, _handleItemToggled: _handleItemToggled, _handleRowContentClick: _handleRowContentClick, actionsMenuVariant: actionsMenuVariant, groupName: groupName, item: item391Data, schema: schema, selectable: selectable, showActionsMenu: showActionsMenu, showCheckbox: showCheckbox, spritemap: spritemap}, null, opt_ijData);
      }
    }
}
exports.rows = $rows;
/**
 * @typedef {{
 *  items: !Array<?>,
 *  schema: {fields: !Array<{contentRenderer: (!goog.soy.data.SanitizedContent|string), contentRendererMap: (?), fieldName: (!goog.soy.data.SanitizedContent|string), fieldsMap: (?), label: (!goog.soy.data.SanitizedContent|string), sortable: boolean, sortingOrder: (!goog.soy.data.SanitizedContent|string)}>, inputName: (!goog.soy.data.SanitizedContent|string), inputNameField: (!goog.soy.data.SanitizedContent|string), inputNamesMap: (?), inputValueField: (!goog.soy.data.SanitizedContent|string)},
 *  _handleCellContentClick: (*|null|undefined),
 *  _handleItemToggled: (*|null|undefined),
 *  _handleRowContentClick: (*|null|undefined),
 *  actionsMenuVariant: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  groupName: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  selectable: (boolean|null|undefined),
 *  showActionsMenu: (boolean|null|undefined),
 *  showCheckbox: (boolean|null|undefined),
 *  spritemap: (!goog.soy.data.SanitizedContent|null|string|undefined)
 * }}
 */
$rows.Params;
if (goog.DEBUG) {
  $rows.soyTemplateName = 'ClayTable.rows';
}


/**
 * @param {{
 *  actionItems: !Array<?>,
 *  spritemap: (!goog.soy.data.SanitizedContent|string)
 * }} opt_data
 * @param {Object<string, *>=} opt_ijData
 * @param {Object<string, *>=} opt_ijData_deprecated
 * @return {void}
 * @suppress {checkTypes}
 */
function __deltemplate_s394_16fb0f20(opt_data, opt_ijData, opt_ijData_deprecated) {
  opt_ijData = opt_ijData_deprecated || opt_ijData;
  /** @type {!Array<?>} */
  var actionItems = soy.asserts.assertType(goog.isArray(opt_data.actionItems), 'actionItems', opt_data.actionItems, '!Array<?>');
  /** @type {!goog.soy.data.SanitizedContent|string} */
  var spritemap = soy.asserts.assertType(goog.isString(opt_data.spritemap) || opt_data.spritemap instanceof goog.soy.data.SanitizedContent, 'spritemap', opt_data.spritemap, '!goog.soy.data.SanitizedContent|string');
  incrementalDom.elementOpen('td');
    incrementalDom.elementOpenStart('div');
        incrementalDom.attr('class', 'quick-action-menu');
    incrementalDom.elementOpenEnd();
      var actionItem412List = actionItems;
      var actionItem412ListLen = actionItem412List.length;
      for (var actionItem412Index = 0; actionItem412Index < actionItem412ListLen; actionItem412Index++) {
          var actionItem412Data = actionItem412List[actionItem412Index];
          if (actionItem412Data.quickAction && actionItem412Data.icon) {
            $templateAlias3({ariaLabel: actionItem412Data.label, elementClasses: 'component-action quick-action-item', href: actionItem412Data.href, icon: actionItem412Data.icon, spritemap: spritemap, title: actionItem412Data.lable}, null, opt_ijData);
          }
        }
    incrementalDom.elementClose('div');
    $templateAlias4({items: actionItems, spritemap: spritemap, triggerClasses: 'component-action'}, null, opt_ijData);
  incrementalDom.elementClose('td');
}
exports.__deltemplate_s394_16fb0f20 = __deltemplate_s394_16fb0f20;
/**
 * @typedef {{
 *  actionItems: !Array<?>,
 *  spritemap: (!goog.soy.data.SanitizedContent|string)
 * }}
 */
__deltemplate_s394_16fb0f20.Params;
if (goog.DEBUG) {
  __deltemplate_s394_16fb0f20.soyTemplateName = 'ClayTable.__deltemplate_s394_16fb0f20';
}
soy.$$registerDelegateFn(soy.$$getDelTemplateId('ClayTable.ActionsMenu.idom'), '', 0, __deltemplate_s394_16fb0f20);


/**
 * @param {{
 *  fieldSchema: (?),
 *  item: (?),
 *  value: (?),
 *  _handleCellContentClick: (*|null|undefined),
 *  spritemap: (!goog.soy.data.SanitizedContent|null|string|undefined)
 * }} opt_data
 * @param {Object<string, *>=} opt_ijData
 * @param {Object<string, *>=} opt_ijData_deprecated
 * @return {void}
 * @suppress {checkTypes}
 */
function __deltemplate_s420_867207ae(opt_data, opt_ijData, opt_ijData_deprecated) {
  opt_ijData = opt_ijData_deprecated || opt_ijData;
  /** @type {?} */
  var fieldSchema = opt_data.fieldSchema;
  /** @type {?} */
  var item = opt_data.item;
  /** @type {?} */
  var value = opt_data.value;
  /** @type {*|null|undefined} */
  var _handleCellContentClick = opt_data._handleCellContentClick;
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var spritemap = soy.asserts.assertType(opt_data.spritemap == null || (goog.isString(opt_data.spritemap) || opt_data.spritemap instanceof goog.soy.data.SanitizedContent), 'spritemap', opt_data.spritemap, '!goog.soy.data.SanitizedContent|null|string|undefined');
  incrementalDom.elementOpen('td');
    incrementalDom.elementOpenStart('span');
        incrementalDom.attr('class', 'text-truncate');
    incrementalDom.elementOpenEnd();
      soyIdom.print(value);
    incrementalDom.elementClose('span');
  incrementalDom.elementClose('td');
}
exports.__deltemplate_s420_867207ae = __deltemplate_s420_867207ae;
/**
 * @typedef {{
 *  fieldSchema: (?),
 *  item: (?),
 *  value: (?),
 *  _handleCellContentClick: (*|null|undefined),
 *  spritemap: (!goog.soy.data.SanitizedContent|null|string|undefined)
 * }}
 */
__deltemplate_s420_867207ae.Params;
if (goog.DEBUG) {
  __deltemplate_s420_867207ae.soyTemplateName = 'ClayTable.__deltemplate_s420_867207ae';
}
soy.$$registerDelegateFn(soy.$$getDelTemplateId('ClayTable.Cell.idom'), '', 0, __deltemplate_s420_867207ae);


/**
 * @param {{
 *  fieldSchema: (?),
 *  item: (?),
 *  value: (?),
 *  _handleCellContentClick: (*|null|undefined),
 *  spritemap: (!goog.soy.data.SanitizedContent|null|string|undefined)
 * }} opt_data
 * @param {Object<string, *>=} opt_ijData
 * @param {Object<string, *>=} opt_ijData_deprecated
 * @return {void}
 * @suppress {checkTypes}
 */
function __deltemplate_s430_067e9412(opt_data, opt_ijData, opt_ijData_deprecated) {
  opt_ijData = opt_ijData_deprecated || opt_ijData;
  /** @type {?} */
  var fieldSchema = opt_data.fieldSchema;
  /** @type {?} */
  var item = opt_data.item;
  /** @type {?} */
  var value = opt_data.value;
  /** @type {*|null|undefined} */
  var _handleCellContentClick = opt_data._handleCellContentClick;
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var spritemap = soy.asserts.assertType(opt_data.spritemap == null || (goog.isString(opt_data.spritemap) || opt_data.spritemap instanceof goog.soy.data.SanitizedContent), 'spritemap', opt_data.spritemap, '!goog.soy.data.SanitizedContent|null|string|undefined');
  incrementalDom.elementOpen('td');
    $templateAlias1({events: {click: _handleCellContentClick}, label: fieldSchema.label, size: 'sm', style: 'secondary', type: fieldSchema.buttonStyle}, null, opt_ijData);
  incrementalDom.elementClose('td');
}
exports.__deltemplate_s430_067e9412 = __deltemplate_s430_067e9412;
/**
 * @typedef {{
 *  fieldSchema: (?),
 *  item: (?),
 *  value: (?),
 *  _handleCellContentClick: (*|null|undefined),
 *  spritemap: (!goog.soy.data.SanitizedContent|null|string|undefined)
 * }}
 */
__deltemplate_s430_067e9412.Params;
if (goog.DEBUG) {
  __deltemplate_s430_067e9412.soyTemplateName = 'ClayTable.__deltemplate_s430_067e9412';
}
soy.$$registerDelegateFn(soy.$$getDelTemplateId('ClayTable.Cell.idom'), 'button', 0, __deltemplate_s430_067e9412);


/**
 * @param {{
 *  fieldSchema: (?),
 *  item: (?),
 *  value: (?),
 *  _handleCellContentClick: (*|null|undefined),
 *  spritemap: (!goog.soy.data.SanitizedContent|null|string|undefined)
 * }} opt_data
 * @param {Object<string, *>=} opt_ijData
 * @param {Object<string, *>=} opt_ijData_deprecated
 * @return {void}
 * @suppress {checkTypes}
 */
function __deltemplate_s445_514ee130(opt_data, opt_ijData, opt_ijData_deprecated) {
  opt_ijData = opt_ijData_deprecated || opt_ijData;
  var $$temp;
  /** @type {?} */
  var fieldSchema = opt_data.fieldSchema;
  /** @type {?} */
  var item = opt_data.item;
  /** @type {?} */
  var value = opt_data.value;
  /** @type {*|null|undefined} */
  var _handleCellContentClick = opt_data._handleCellContentClick;
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var spritemap = soy.asserts.assertType(opt_data.spritemap == null || (goog.isString(opt_data.spritemap) || opt_data.spritemap instanceof goog.soy.data.SanitizedContent), 'spritemap', opt_data.spritemap, '!goog.soy.data.SanitizedContent|null|string|undefined');
  incrementalDom.elementOpen('td');
    if (value) {
      var label470List = value;
      var label470ListLen = label470List.length;
      for (var label470Index = 0; label470Index < label470ListLen; label470Index++) {
          var label470Data = label470List[label470Index];
          var style__soy457 = '';
          style__soy457 += fieldSchema.labelStylesMap ? (($$temp = fieldSchema.labelStylesMap[label470Data]) == null ? fieldSchema.labelStylesMap['*'] : $$temp) : '';
          $templateAlias5({label: label470Data, style: style__soy457 != '' ? style__soy457 : null}, null, opt_ijData);
        }
    }
  incrementalDom.elementClose('td');
}
exports.__deltemplate_s445_514ee130 = __deltemplate_s445_514ee130;
/**
 * @typedef {{
 *  fieldSchema: (?),
 *  item: (?),
 *  value: (?),
 *  _handleCellContentClick: (*|null|undefined),
 *  spritemap: (!goog.soy.data.SanitizedContent|null|string|undefined)
 * }}
 */
__deltemplate_s445_514ee130.Params;
if (goog.DEBUG) {
  __deltemplate_s445_514ee130.soyTemplateName = 'ClayTable.__deltemplate_s445_514ee130';
}
soy.$$registerDelegateFn(soy.$$getDelTemplateId('ClayTable.Cell.idom'), 'label', 0, __deltemplate_s445_514ee130);


/**
 * @param {{
 *  fieldSchema: (?),
 *  item: (?),
 *  value: (?),
 *  _handleCellContentClick: (*|null|undefined),
 *  spritemap: (!goog.soy.data.SanitizedContent|null|string|undefined)
 * }} opt_data
 * @param {Object<string, *>=} opt_ijData
 * @param {Object<string, *>=} opt_ijData_deprecated
 * @return {void}
 * @suppress {checkTypes}
 */
function __deltemplate_s474_49cf592d(opt_data, opt_ijData, opt_ijData_deprecated) {
  opt_ijData = opt_ijData_deprecated || opt_ijData;
  /** @type {?} */
  var fieldSchema = opt_data.fieldSchema;
  /** @type {?} */
  var item = opt_data.item;
  /** @type {?} */
  var value = opt_data.value;
  /** @type {*|null|undefined} */
  var _handleCellContentClick = opt_data._handleCellContentClick;
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var spritemap = soy.asserts.assertType(opt_data.spritemap == null || (goog.isString(opt_data.spritemap) || opt_data.spritemap instanceof goog.soy.data.SanitizedContent), 'spritemap', opt_data.spritemap, '!goog.soy.data.SanitizedContent|null|string|undefined');
  incrementalDom.elementOpen('td');
    $templateAlias3({elementClasses: 'text-truncate', href: item[fieldSchema.hrefFieldName], label: value}, null, opt_ijData);
  incrementalDom.elementClose('td');
}
exports.__deltemplate_s474_49cf592d = __deltemplate_s474_49cf592d;
/**
 * @typedef {{
 *  fieldSchema: (?),
 *  item: (?),
 *  value: (?),
 *  _handleCellContentClick: (*|null|undefined),
 *  spritemap: (!goog.soy.data.SanitizedContent|null|string|undefined)
 * }}
 */
__deltemplate_s474_49cf592d.Params;
if (goog.DEBUG) {
  __deltemplate_s474_49cf592d.soyTemplateName = 'ClayTable.__deltemplate_s474_49cf592d';
}
soy.$$registerDelegateFn(soy.$$getDelTemplateId('ClayTable.Cell.idom'), 'link', 0, __deltemplate_s474_49cf592d);


/**
 * @param {{
 *  fieldSchema: (?),
 *  item: (?),
 *  value: (?),
 *  _handleCellContentClick: (*|null|undefined),
 *  spritemap: (!goog.soy.data.SanitizedContent|null|string|undefined)
 * }} opt_data
 * @param {Object<string, *>=} opt_ijData
 * @param {Object<string, *>=} opt_ijData_deprecated
 * @return {void}
 * @suppress {checkTypes}
 */
function __deltemplate_s487_fbd84735(opt_data, opt_ijData, opt_ijData_deprecated) {
  opt_ijData = opt_ijData_deprecated || opt_ijData;
  /** @type {?} */
  var fieldSchema = opt_data.fieldSchema;
  /** @type {?} */
  var item = opt_data.item;
  /** @type {?} */
  var value = opt_data.value;
  /** @type {*|null|undefined} */
  var _handleCellContentClick = opt_data._handleCellContentClick;
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var spritemap = soy.asserts.assertType(opt_data.spritemap == null || (goog.isString(opt_data.spritemap) || opt_data.spritemap instanceof goog.soy.data.SanitizedContent), 'spritemap', opt_data.spritemap, '!goog.soy.data.SanitizedContent|null|string|undefined');
  incrementalDom.elementOpenStart('td');
      incrementalDom.attr('class', 'table-cell-expand');
  incrementalDom.elementOpenEnd();
    incrementalDom.elementOpenStart('p');
        incrementalDom.attr('class', 'table-list-title');
    incrementalDom.elementOpenEnd();
      incrementalDom.elementOpenStart('span');
          incrementalDom.attr('class', 'text-truncate-inline');
      incrementalDom.elementOpenEnd();
        if (item.href) {
          $templateAlias3({elementClasses: 'text-truncate', href: item.href, label: value}, null, opt_ijData);
        } else {
          incrementalDom.elementOpenStart('span');
              incrementalDom.attr('class', 'text-truncate');
          incrementalDom.elementOpenEnd();
            soyIdom.print(value);
          incrementalDom.elementClose('span');
        }
      incrementalDom.elementClose('span');
    incrementalDom.elementClose('p');
  incrementalDom.elementClose('td');
}
exports.__deltemplate_s487_fbd84735 = __deltemplate_s487_fbd84735;
/**
 * @typedef {{
 *  fieldSchema: (?),
 *  item: (?),
 *  value: (?),
 *  _handleCellContentClick: (*|null|undefined),
 *  spritemap: (!goog.soy.data.SanitizedContent|null|string|undefined)
 * }}
 */
__deltemplate_s487_fbd84735.Params;
if (goog.DEBUG) {
  __deltemplate_s487_fbd84735.soyTemplateName = 'ClayTable.__deltemplate_s487_fbd84735';
}
soy.$$registerDelegateFn(soy.$$getDelTemplateId('ClayTable.Cell.idom'), 'main', 0, __deltemplate_s487_fbd84735);


/**
 * @param {{
 *  fieldSchema: (?),
 *  item: (?),
 *  value: (?),
 *  _handleCellContentClick: (*|null|undefined),
 *  spritemap: (!goog.soy.data.SanitizedContent|null|string|undefined)
 * }} opt_data
 * @param {Object<string, *>=} opt_ijData
 * @param {Object<string, *>=} opt_ijData_deprecated
 * @return {void}
 * @suppress {checkTypes}
 */
function __deltemplate_s508_cb955dc3(opt_data, opt_ijData, opt_ijData_deprecated) {
  opt_ijData = opt_ijData_deprecated || opt_ijData;
  /** @type {?} */
  var fieldSchema = opt_data.fieldSchema;
  /** @type {?} */
  var item = opt_data.item;
  /** @type {?} */
  var value = opt_data.value;
  /** @type {*|null|undefined} */
  var _handleCellContentClick = opt_data._handleCellContentClick;
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var spritemap = soy.asserts.assertType(opt_data.spritemap == null || (goog.isString(opt_data.spritemap) || opt_data.spritemap instanceof goog.soy.data.SanitizedContent), 'spritemap', opt_data.spritemap, '!goog.soy.data.SanitizedContent|null|string|undefined');
  incrementalDom.elementOpenStart('td');
      incrementalDom.attr('class', 'text-right');
  incrementalDom.elementOpenEnd();
    soyIdom.print(value);
  incrementalDom.elementClose('td');
}
exports.__deltemplate_s508_cb955dc3 = __deltemplate_s508_cb955dc3;
/**
 * @typedef {{
 *  fieldSchema: (?),
 *  item: (?),
 *  value: (?),
 *  _handleCellContentClick: (*|null|undefined),
 *  spritemap: (!goog.soy.data.SanitizedContent|null|string|undefined)
 * }}
 */
__deltemplate_s508_cb955dc3.Params;
if (goog.DEBUG) {
  __deltemplate_s508_cb955dc3.soyTemplateName = 'ClayTable.__deltemplate_s508_cb955dc3';
}
soy.$$registerDelegateFn(soy.$$getDelTemplateId('ClayTable.Cell.idom'), 'number', 0, __deltemplate_s508_cb955dc3);


/**
 * @param {{
 *  fieldSchema: (?),
 *  item: (?),
 *  value: (?),
 *  _handleCellContentClick: (*|null|undefined),
 *  spritemap: (!goog.soy.data.SanitizedContent|null|string|undefined)
 * }} opt_data
 * @param {Object<string, *>=} opt_ijData
 * @param {Object<string, *>=} opt_ijData_deprecated
 * @return {void}
 * @suppress {checkTypes}
 */
function __deltemplate_s518_3547edb9(opt_data, opt_ijData, opt_ijData_deprecated) {
  opt_ijData = opt_ijData_deprecated || opt_ijData;
  /** @type {?} */
  var fieldSchema = opt_data.fieldSchema;
  /** @type {?} */
  var item = opt_data.item;
  /** @type {?} */
  var value = opt_data.value;
  /** @type {*|null|undefined} */
  var _handleCellContentClick = opt_data._handleCellContentClick;
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var spritemap = soy.asserts.assertType(opt_data.spritemap == null || (goog.isString(opt_data.spritemap) || opt_data.spritemap instanceof goog.soy.data.SanitizedContent), 'spritemap', opt_data.spritemap, '!goog.soy.data.SanitizedContent|null|string|undefined');
  incrementalDom.elementOpen('td');
    $templateAlias6({maxValue: fieldSchema.maxValue, minValue: fieldSchema.minValue, value: value}, null, opt_ijData);
  incrementalDom.elementClose('td');
}
exports.__deltemplate_s518_3547edb9 = __deltemplate_s518_3547edb9;
/**
 * @typedef {{
 *  fieldSchema: (?),
 *  item: (?),
 *  value: (?),
 *  _handleCellContentClick: (*|null|undefined),
 *  spritemap: (!goog.soy.data.SanitizedContent|null|string|undefined)
 * }}
 */
__deltemplate_s518_3547edb9.Params;
if (goog.DEBUG) {
  __deltemplate_s518_3547edb9.soyTemplateName = 'ClayTable.__deltemplate_s518_3547edb9';
}
soy.$$registerDelegateFn(soy.$$getDelTemplateId('ClayTable.Cell.idom'), 'progressbar', 0, __deltemplate_s518_3547edb9);


/**
 * @param {{
 *  fieldSchema: (?),
 *  item: (?),
 *  value: (?),
 *  _handleCellContentClick: (*|null|undefined),
 *  spritemap: (!goog.soy.data.SanitizedContent|null|string|undefined)
 * }} opt_data
 * @param {Object<string, *>=} opt_ijData
 * @param {Object<string, *>=} opt_ijData_deprecated
 * @return {void}
 * @suppress {checkTypes}
 */
function __deltemplate_s531_cc0a3bee(opt_data, opt_ijData, opt_ijData_deprecated) {
  opt_ijData = opt_ijData_deprecated || opt_ijData;
  /** @type {?} */
  var fieldSchema = opt_data.fieldSchema;
  /** @type {?} */
  var item = opt_data.item;
  /** @type {?} */
  var value = opt_data.value;
  /** @type {*|null|undefined} */
  var _handleCellContentClick = opt_data._handleCellContentClick;
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var spritemap = soy.asserts.assertType(opt_data.spritemap == null || (goog.isString(opt_data.spritemap) || opt_data.spritemap instanceof goog.soy.data.SanitizedContent), 'spritemap', opt_data.spritemap, '!goog.soy.data.SanitizedContent|null|string|undefined');
  incrementalDom.elementOpen('td');
    if (value) {
      var content__soy542 = function() {
        var alt__soy544 = item[fieldSchema.altFieldName];
        var attributes__soy546 = function() {
          if (alt__soy544) {
            incrementalDom.attr('alt', alt__soy544);
          }
          incrementalDom.attr('class', 'table-img');
          incrementalDom.attr('src', value);
        };
        incrementalDom.elementOpenStart('img');
            attributes__soy546();
        incrementalDom.elementOpenEnd();
        incrementalDom.elementClose('img');
      };
      if (fieldSchema.autofitImage) {
        incrementalDom.elementOpenStart('div');
            incrementalDom.attr('class', 'autofit-row');
        incrementalDom.elementOpenEnd();
          incrementalDom.elementOpenStart('div');
              incrementalDom.attr('class', 'autofit-col');
          incrementalDom.elementOpenEnd();
            content__soy542();
          incrementalDom.elementClose('div');
        incrementalDom.elementClose('div');
      } else {
        content__soy542();
      }
    }
  incrementalDom.elementClose('td');
}
exports.__deltemplate_s531_cc0a3bee = __deltemplate_s531_cc0a3bee;
/**
 * @typedef {{
 *  fieldSchema: (?),
 *  item: (?),
 *  value: (?),
 *  _handleCellContentClick: (*|null|undefined),
 *  spritemap: (!goog.soy.data.SanitizedContent|null|string|undefined)
 * }}
 */
__deltemplate_s531_cc0a3bee.Params;
if (goog.DEBUG) {
  __deltemplate_s531_cc0a3bee.soyTemplateName = 'ClayTable.__deltemplate_s531_cc0a3bee';
}
soy.$$registerDelegateFn(soy.$$getDelTemplateId('ClayTable.Cell.idom'), 'image', 0, __deltemplate_s531_cc0a3bee);

exports.render.params = ["schema","_handleCellContentClick","_handleItemToggled","_handleRowContentClick","_handleSortingClick","actionsMenuVariant","elementClasses","id","items","selectable","showActionsMenu","showCheckbox","size","spritemap","tableClasses","useDefaultClasses","wrapTable"];
exports.render.types = {"schema":"[\n\t\t\tfields: list<[\n\t\t\tcontentRenderer: string,\n\t\t\tcontentRendererMap: ?,\n\t\t\tfieldName: string,\n\t\t\tfieldsMap: ?,\n\t\t\tlabel: string,\n\t\t\tsortable: bool,\n\t\t\tsortingOrder: string\n\t\t]>,\n\t\tinputName: string,\n\t\tinputNameField: string,\n\t\tinputNamesMap: ?,\n\t\tinputValueField: string\n\t]","_handleCellContentClick":"any","_handleItemToggled":"any","_handleRowContentClick":"any","_handleSortingClick":"any","actionsMenuVariant":"string","elementClasses":"string","id":"string","items":"list<?>","selectable":"bool","showActionsMenu":"bool","showCheckbox":"bool","size":"string","spritemap":"string","tableClasses":"string","useDefaultClasses":"bool","wrapTable":"bool"};
exports.body.params = ["schema","_handleCellContentClick","_handleItemToggled","_handleRowContentClick","actionsMenuVariant","id","items","selectable","showActionsMenu","showCheckbox","spritemap"];
exports.body.types = {"schema":"[\n\t\t\tfields: list<[\n\t\t\tcontentRenderer: string,\n\t\t\tcontentRendererMap: ?,\n\t\t\tfieldName: string,\n\t\t\tfieldsMap: ?,\n\t\t\tlabel: string,\n\t\t\tsortable: bool,\n\t\t\tsortingOrder: string\n\t\t]>,\n\t\tinputName: string,\n\t\tinputNameField: string,\n\t\tinputNamesMap: ?,\n\t\tinputValueField: string\n\t]","_handleCellContentClick":"any","_handleItemToggled":"any","_handleRowContentClick":"any","actionsMenuVariant":"string","id":"string","items":"list<?>","selectable":"bool","showActionsMenu":"bool","showCheckbox":"bool","spritemap":"string"};
exports.header.params = ["schema","_handleSortingClick","selectable","showActionsMenu","showCheckbox","spritemap"];
exports.header.types = {"schema":"[\n\t\t\tfields: list<[\n\t\t\tcontentRenderer: string,\n\t\t\tcontentRendererMap: ?,\n\t\t\tfieldName: string,\n\t\t\tfieldsMap: ?,\n\t\t\tlabel: string,\n\t\t\tsortable: bool,\n\t\t\tsortingOrder: string\n\t\t]>,\n\t\tinputName: string,\n\t\tinputNameField: string,\n\t\tinputNamesMap: ?,\n\t\tinputValueField: string\n\t]","_handleSortingClick":"any","selectable":"bool","showActionsMenu":"bool","showCheckbox":"bool","spritemap":"string"};
exports.row.params = ["item","schema","_handleCellContentClick","_handleItemToggled","_handleRowContentClick","actionsMenuVariant","groupName","selectable","showActionsMenu","showCheckbox","spritemap"];
exports.row.types = {"item":"?","schema":"[\n\t\t\tfields: list<[\n\t\t\tcontentRenderer: string,\n\t\t\tcontentRendererMap: ?,\n\t\t\tfieldName: string,\n\t\t\tfieldsMap: ?,\n\t\t\tlabel: string,\n\t\t\tsortable: bool,\n\t\t\tsortingOrder: string\n\t\t]>,\n\t\tinputName: string,\n\t\tinputNameField: string,\n\t\tinputNamesMap: ?,\n\t\tinputValueField: string\n\t]","_handleCellContentClick":"any","_handleItemToggled":"any","_handleRowContentClick":"any","actionsMenuVariant":"string","groupName":"string","selectable":"bool","showActionsMenu":"bool","showCheckbox":"bool","spritemap":"string"};
exports.rows.params = ["items","schema","_handleCellContentClick","_handleItemToggled","_handleRowContentClick","actionsMenuVariant","groupName","selectable","showActionsMenu","showCheckbox","spritemap"];
exports.rows.types = {"items":"list<?>","schema":"[\n\t\tfields: list<[\n\t\t\tcontentRenderer: string,\n\t\t\tcontentRendererMap: ?,\n\t\t\tfieldName: string,\n\t\t\tfieldsMap: ?,\n\t\t\tlabel: string,\n\t\t\tsortable: bool,\n\t\t\tsortingOrder: string\n\t\t]>,\n\t\tinputName: string,\n\t\tinputNameField: string,\n\t\tinputNamesMap: ?,\n\t\tinputValueField: string\n\t]","_handleCellContentClick":"any","_handleItemToggled":"any","_handleRowContentClick":"any","actionsMenuVariant":"string","groupName":"string","selectable":"bool","showActionsMenu":"bool","showCheckbox":"bool","spritemap":"string"};
templates = exports;
return exports;

});

class ClayTable extends Component {}
Soy.register(ClayTable, templates);
export { ClayTable, templates };
export default templates;
/* jshint ignore:end */
